import { sendWebsocketMessage } from "../../../../../../App";
import { cloneDeep } from 'lodash';

export const exportTradePlan = ({ data, templateTitle, tags, description }) => {
    // make deep copy of trade plan data object
    const dataCopy = cloneDeep(data);

    //sanitize sensitive data and add id property
    dataCopy.id = new Date().getTime();
    dataCopy.accountNumber = 'none';
    dataCopy.brokerage = 'none';
    const entryTacticsArr = Object.keys(dataCopy.entryTactics);
    for (const tactic of entryTacticsArr) {
        dataCopy.entryTactics[tactic]['quantityBasisValue'] = 0;
    }

    // if option is selected, remove expiration dates and option choices
    if (dataCopy.instrument === 'option') {
        dataCopy.optionManagement.optionChoices = {};
        dataCopy.optionManagement.expirationDates = [];
    }

    // create msg object
    const msg = {
        messageType: 'exportTemplateToHome',
        tags,
        template: dataCopy,
        templateName: templateTitle,
        description,
    };
    //convert to json string
    // const msgJson = JSON.stringify(msg);
    //send via websocket
    sendWebsocketMessage(msg);
};
